module.exports = __webpack_public_path__ + "img/nbg.f5ec37e9.png";